import app from '@/app';
import templateUrl from './decision-tree-button.html';


  app.component('prDecisionTreeButton', {
    templateUrl,
    bindings: {
      type: '@',
      state: '@',
      params: '<'
    }
  });
